import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const householdFields: FieldInterface[] = [
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
]

const householdRelations: RelationInterface[] = [
  {
    key: '_people',
    originKey: 'people',
    objectType: OBJECT_TYPES.person,
    isMultiple: true,
  },
  {
    key: '_relations',
    originKey: 'relations',
    objectType: OBJECT_TYPES.relation,
    isMultiple: true,
  },
  {
    key: '_income',
    originKey: 'income',
    objectType: OBJECT_TYPES.genericModel,
  },
  {
    key: '_charge',
    originKey: 'charge',
    objectType: OBJECT_TYPES.genericModel,
  },
  {
    key: '_portfolios',
    originKey: 'portfolios',
    objectType: OBJECT_TYPES.portfolio,
    isMultiple: true,
  },
]

export { householdFields, householdRelations }
